import { Link, useNavigate } from 'react-router-dom';
import { cn } from '../../lib/cn';
import { ChevronRight, ArrowLeft } from 'lucide-react';

export function PageHeader({ title, subtitle, actions, breadcrumb, showBack = true, className }) {
  const navigate = useNavigate();
  // Back goes to the second-to-last breadcrumb's href if present (e.g.
  // Designations -> Settings), otherwise just pops browser history.
  const backHref = breadcrumb?.length > 1 ? breadcrumb[breadcrumb.length - 2]?.href : null;
  const handleBack = () => (backHref ? navigate(backHref) : navigate(-1));

  return (
    <div className={cn('flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3', className)}>
      <div>
        {breadcrumb && (
          <div className="flex items-center gap-1 mb-1.5">
            {showBack && (
              <button onClick={handleBack} aria-label="Back"
                className="mr-1.5 w-6 h-6 flex items-center justify-center rounded-[6px] text-[var(--text-secondary)] hover:bg-[var(--bg-hover)] hover:text-[var(--text-primary)] transition-colors shrink-0">
                <ArrowLeft size={14} />
              </button>
            )}
            {breadcrumb.map((item, i) => {
              const isLast = i === breadcrumb.length - 1;
              const label = item?.label ?? item;
              return (
                <span key={i} className="flex items-center gap-1">
                  {i > 0 && <ChevronRight size={12} className="text-[var(--text-tertiary)]" />}
                  {!isLast && item?.href ? (
                    <Link to={item.href} className="text-[12px] text-[var(--text-tertiary)] hover:text-[var(--accent)] hover:underline transition-colors">
                      {label}
                    </Link>
                  ) : (
                    <span className={cn('text-[12px]', isLast ? 'text-[var(--text-secondary)] font-medium' : 'text-[var(--text-tertiary)]')}>{label}</span>
                  )}
                </span>
              );
            })}
          </div>
        )}
        <h1 className="text-[22px] font-bold text-[var(--text-primary)] leading-tight">{title}</h1>
        {subtitle && <p className="text-[13px] text-[var(--text-secondary)] mt-0.5">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}
export default PageHeader;
